import { selectSelectedBusinessProfile } from '@store/business/BusinessProfileReducer'
import { useAppSelector } from '@store/hooks'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule } from '@utils/rules'
import { Form, Input } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedBusinessProfile())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="status" label="Status" rules={[requiredRule()]} required>
        <SBAsyncSelect
          allowClear
          placeholder="Status"
          entity={Entity.businessProfileStatus}
          searchFieldName="name"
        />
      </Form.Item>
    </Form>
  )
}

export default Update
